import React, { memo } from "react";
import { Row } from "react-bootstrap";
import Batteries from "../widgets/Batteries";
import Totals from "../widgets/Totals";
import Locations from "../widgets/Locations";
import Certificates from "../widgets/Certificates";
import PropTypes from 'prop-types';

const WidgetRow = ({ data, loading }) => {
    return (
        <Row className="g-4 mb-4">
            <Totals data={data?.tableData} loading={loading} />
            <Locations data={data?.trackerData} loading={loading} />
            <Certificates data={data?.tableData.filter(x => x.stillageTypeName.includes('craneable'))} loading={loading} />
            <Batteries data={data} loading={loading} />
        </Row>
    )
}

WidgetRow.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
};

export default memo(WidgetRow);